import { AnyChart } from '@d3fc/d3fc-chart';
import { NumberFormat } from '@instinet-analytics/core-lib';

export function renderXAxis(
    numberFormat: NumberFormat,
    chart: AnyChart,
    maxX: number,
    minX: number
) {
    chart.xTickFormat((d: number) => {
        if (d === 0 && minX === 0) {
            return '';
        }
        if (maxX >= 2000000 || minX <= -2000000) {
            return numberFormat.n0(d / 1000000) + 'M';
        }
        if (maxX >= 2000 || minX <= -2000) {
            return numberFormat.n0(d / 1000) + 'K';
        }
        return numberFormat.n0(d);
    });
}
